// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideBarUserInfo_main__4k0uT {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0 10px 0 15px;
    cursor: pointer;
    border-radius: 6px;
}

.SideBarUserInfo_main__4k0uT:hover {
    background-color: rgba(255, 255, 255, 0.15);
}

.SideBarUserInfo_avatar__2g9w0 {
    width: 32px;
    height: 32px;
    border-radius: 50%;
}

.SideBarUserInfo_username__GM5bN {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: calc(100% - 32px - 14px - 14px);
    height: 100%;
    padding-left: 10px;
    font-size: 14px;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.SideBarUserInfo_logout_img__EJtLZ {
    width: 14px;
    height: 14px;
}

.SideBarUserInfo_logout_butn__daUQD {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
}

.SideBarUserInfo_logout_red_img__6I6My {
    width: 16px;
    height: 16px;
}

.SideBarUserInfo_logout_text__GeP2y {
    padding-left: 5px;
    font-size: 14px;
    color: #E31A1A;
}

.SideBarUserInfo_userinfo_butn__Chc1Y {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
}

.SideBarUserInfo_userinfo_text_box__oua9G {
    display: flex;
    flex-direction: column;
    width: 90%;
    height: 100%;
}

.SideBarUserInfo_userinfo_username__B19aq {
    color: #605D64;
}

.SideBarUserInfo_userinfo_email__jdy0Q {
    color: #7E8B9E;
}

.SideBarUserInfo_userinfo_setting__5BU3- {
    width: 13px;
    height: 14px;
}


.userinfo_dropdown .ant-dropdown-menu .ant-dropdown-menu-item {
    padding: 0;
}

.SideBarUserInfo_logout_butn__daUQD,
.SideBarUserInfo_userinfo_butn__Chc1Y {
    padding: 5px 12px;
}

.SideBarUserInfo_admin_text_box__Ia7WS {
    color: #7e8b9e;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/SideBarUserInfo/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,sCAAsC;IACtC,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,UAAU;AACd;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".main {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    padding: 0 10px 0 15px;\n    cursor: pointer;\n    border-radius: 6px;\n}\n\n.main:hover {\n    background-color: rgba(255, 255, 255, 0.15);\n}\n\n.avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n}\n\n.username {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: calc(100% - 32px - 14px - 14px);\n    height: 100%;\n    padding-left: 10px;\n    font-size: 14px;\n    color: #fff;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.logout_img {\n    width: 14px;\n    height: 14px;\n}\n\n.logout_butn {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.logout_red_img {\n    width: 16px;\n    height: 16px;\n}\n\n.logout_text {\n    padding-left: 5px;\n    font-size: 14px;\n    color: #E31A1A;\n}\n\n.userinfo_butn {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.userinfo_text_box {\n    display: flex;\n    flex-direction: column;\n    width: 90%;\n    height: 100%;\n}\n\n.userinfo_username {\n    color: #605D64;\n}\n\n.userinfo_email {\n    color: #7E8B9E;\n}\n\n.userinfo_setting {\n    width: 13px;\n    height: 14px;\n}\n\n\n:global(.userinfo_dropdown .ant-dropdown-menu .ant-dropdown-menu-item) {\n    padding: 0;\n}\n\n.logout_butn,\n.userinfo_butn {\n    padding: 5px 12px;\n}\n\n.admin_text_box {\n    color: #7e8b9e;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `SideBarUserInfo_main__4k0uT`,
	"avatar": `SideBarUserInfo_avatar__2g9w0`,
	"username": `SideBarUserInfo_username__GM5bN`,
	"logout_img": `SideBarUserInfo_logout_img__EJtLZ`,
	"logout_butn": `SideBarUserInfo_logout_butn__daUQD`,
	"logout_red_img": `SideBarUserInfo_logout_red_img__6I6My`,
	"logout_text": `SideBarUserInfo_logout_text__GeP2y`,
	"userinfo_butn": `SideBarUserInfo_userinfo_butn__Chc1Y`,
	"userinfo_text_box": `SideBarUserInfo_userinfo_text_box__oua9G`,
	"userinfo_username": `SideBarUserInfo_userinfo_username__B19aq`,
	"userinfo_email": `SideBarUserInfo_userinfo_email__jdy0Q`,
	"userinfo_setting": `SideBarUserInfo_userinfo_setting__5BU3-`,
	"admin_text_box": `SideBarUserInfo_admin_text_box__Ia7WS`
};
export default ___CSS_LOADER_EXPORT___;
